// extracted by css-extract-rspack-plugin
export default {"topBarContainer":"MonetaryVerificationsTopBar_topBarContainer__ouSzh"};